import React, { Component } from 'react';

class IconReportSuccess extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="36"
                height="37"
                fill="none"
                viewBox="0 0 36 37"
            >
                <path
                    fill="#54B91B"
                    fillRule="evenodd"
                    d="M17.987 2.5c8.84-.013 16.026 7.16 16.013 16 0 8.853-7.133 15.987-15.987 16C9.173 34.513 1.987 27.34 2 18.487A15.99 15.99 0 0117.987 2.5zm.026 3.187c-7.026-.014-12.8 5.733-12.826 12.8-.027 7.026 5.72 12.786 12.786 12.84 7.014.053 12.84-5.76 12.854-12.814 0-7.053-5.76-12.813-12.814-12.826z"
                    clipRule="evenodd"
                ></path>
                <path
                    fill="#54B91B"
                    d="M27.652 12.7c-.173-.587-.6-1.04-1.16-1.2-.733-.227-1.386-.054-1.96.52l-9.173 9.173c-1.293-1.307-2.6-2.6-3.893-3.893-.627-.627-1.454-.787-2.16-.44-.56.28-.934.76-1.027 1.346-.08.574.12 1.174.573 1.627 1.734 1.733 3.454 3.467 5.2 5.187.214.213.467.373.734.466.173.067.386.107.613.107.413 0 .893-.147 1.36-.627L27.026 14.7c.106-.107.213-.227.32-.347.373-.453.48-1.067.306-1.653z"
                ></path>
            </svg>
        );
    }
}

export default IconReportSuccess;